export default __webpack_public_path__ + "static/media/kanta_approval.ac08fba7.png";